/** Procedural wind blades stay crisp at every pixel ratio and rotation. */
export function drawChakra(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number,
  rotation: number,
  formation = 1,
): void {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(rotation);
  const glow = ctx.createRadialGradient(0, 0, 1, 0, 0, radius * 2);
  glow.addColorStop(0, 'rgba(226,253,255,.95)');
  glow.addColorStop(0.3, 'rgba(89,209,255,.55)');
  glow.addColorStop(1, 'rgba(62,191,255,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(-radius * 2, -radius * 2, radius * 4, radius * 4);
  ctx.save();
  ctx.globalAlpha *= formation;
  const reach = radius * (0.55 + 1.3 * formation);
  for (let i = 0; i < 4; i++) {
    ctx.rotate(Math.PI / 2);
    ctx.fillStyle = '#cefbff';
    ctx.strokeStyle = '#58cdfa';
    ctx.lineWidth = 1.2;
    ctx.beginPath();
    ctx.moveTo(radius * 0.2, -radius * 0.28);
    ctx.quadraticCurveTo(radius * 0.8, -radius * 0.25, reach, -radius * 0.12);
    ctx.quadraticCurveTo(radius * 0.9, radius * 0.2, radius * 0.25, radius * 0.26);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }
  ctx.restore();
  ctx.fillStyle = '#f0feff';
  ctx.beginPath();
  ctx.arc(0, 0, radius * 0.49, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#54bfee';
  ctx.lineWidth = 1.6;
  for (let i = 0; i < 3; i++) {
    ctx.rotate(Math.PI / 3);
    ctx.beginPath();
    ctx.ellipse(0, 0, radius * 0.43, radius * 0.2, 0, 0, Math.PI * 2);
    ctx.stroke();
  }
  ctx.restore();
}
